import Icon from '@/components/UI/Icon';
import { Draggable } from '@hello-pangea/dnd';
import type { FC, ReactNode } from 'react';
import './sortable.scss';

interface SortableItemProps {
  id: string;
  index: number;
  showDraggableIcon?: boolean;
  isDragDisabled?: boolean;
  className?: string;
  children: ReactNode;
}

const SortableItem: FC<SortableItemProps> = ({
  id,
  index,
  showDraggableIcon = false,
  isDragDisabled = false,
  className = '',
  children,
}) => {
  return (
    <Draggable draggableId={id} index={index} isDragDisabled={isDragDisabled}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          className={`${snapshot.isDragging ? 'o-80' : ''} movable ${className}`}
          data-dragging={snapshot.isDragging || undefined}
        >
          <div>{children}</div>
          {showDraggableIcon && <Icon icon="drag" className="dib mid-gray" width="20" height="20" />}
        </div>
      )}
    </Draggable>
  );
};

export default SortableItem;
